// Универсальный хелпер для формирования sessionQuestions
// Использовать везде, где нужен массив вопросов с ответами для сохранения/расчёта/отображения

export function buildSessionQuestions(questions) {
  if (!Array.isArray(questions)) return [];
  return questions
    .filter(q => q && typeof q.id === 'string' && q.id && typeof q.text === 'string' && q.text && q.answer !== undefined && q.answer !== null && q.answer !== '')
    .map(q => ({ id: q.id, text: q.text, answer: q.answer }));
} 